import { useCallback, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import { ICollection } from "../../../utils/interfaces/collection.interface";
import { handleBackendError } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { IPaginationParams } from "../../../utils/interfaces/pagination-params.interface";
import { IResource } from "../../../utils/interfaces/resource.interface";
import UnitRepository from "../../../repositories/unit-repository";
import { UnitList } from "../list/interface";
import { Unit } from "../../../models/unit";

export const useGetUnit = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<UnitList[]>([]);
  const [totalData, setTotalData] = useState<number>(0);
  const [isOnFetchingData, setIsOnFetchingData] = useState<boolean>(false);

  const [unitData, setUnitData] = useState<Unit | null>(null);
  const [isOnFetchingUnitData, setIsOnFetchingUnitData] =
    useState<boolean>(false);

  const loadData = useCallback(async (params: IPaginationParams) => {
    setIsOnFetchingData(true);

    await UnitRepository.all(params)
      .then((response: AxiosResponse<ICollection<UnitList[]>>) => {
        setData(response.data.data);
        setTotalData(response.data.meta.total);
      })
      .catch(() => {})
      .finally(() => {
        setIsOnFetchingData(false);
      });
  }, []);

  const loadUnitData = useCallback(
    async (id: string, params: any = null) => {
      setIsOnFetchingUnitData(true);

      await UnitRepository.show(id, params)
        .then((response: AxiosResponse<IResource<Unit>>) => {
          setUnitData(response.data.data);
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setIsOnFetchingUnitData(false);
        });
    },
    [t]
  );

  return {
    data,
    totalData,
    loadData,
    isOnFetchingData,
    loadUnitData,
    isOnFetchingUnitData,
    unitData,
  };
};
